import { defineMessages } from 'react-intl';

export default defineMessages({
  getAdvancedStarted: {
    id: 'view.choosePricing.planPreview.getAdvancedStarted',
    defaultMessage: 'Get advanced started',
  },
  getStarted: {
    id: 'view.choosePricing.planPreview.getStarted',
    defaultMessage: 'Get started',
  },
  isActive: {
    id: 'view.choosePricing.planPreview.isActive',
    defaultMessage: 'Active',
  },
});
